@if (isLoading) {
  <div
    class="d-flex justify-content-center align-items-center h-100"
    >
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">loading...</span>
    </div>
  </div>
} @else {
  @if (applications.length > 0) {
    <div>
      <!-- Applications container -->
      <div class="d-grid overflow-hidden application-container">
        <!-- Box title -->
        <span class="text-primary fs-6 fw-bold mb-2">Talentpool</span>
        <!-- Applications list -->
        @for (application of applications; track application) {
            <div
              class="card-custom p-4 bg-light-discret rounded-4 d-flex align-items-center"
              (click)="navigateToTalentPool(application.id)"
              >
              <div class="d-flex flex-column gap-2 card-content">
                <div class="d-flex align-items-center gap-2">
                  <img
                [src]="
                  getFullImageUrl(
                    application?.attributes?.portrait?.data?.attributes?.formats
                      ?.thumbnail?.url
                  )
                "
                [title]="
                  application?.attributes?.portrait?.data?.attributes?.formats?.thumbnail
                    ?.name
                "
                    class="rounded-circle img-thumbnail"
                    loading="lazy"
                    lcImgFallback
                    />
                  <div class="card-text">
                    <div class="fw-bold text-truncate">
                      {{ application?.attributes?.personalInfo?.data?.attributes?.givenName }}
                      {{
                      application?.attributes?.personalInfo?.data?.attributes?.familyName
                      }}
                    </div>
                    <div class="text-secondary text-truncate">
                      {{ application?.attributes?.personalInfo?.data?.attributes?.email }}
                    </div>
                  </div>
                </div>
                <div>
                  @if (application?.attributes?.workExperience?.experienceIns?.data) {
                    <div
                      class="d-flex flex-wrap gap-2"
                      >
                      @for (
                        workExperience of application.attributes.workExperience
                        .experienceIns.data
                        ; track
                        workExperience) {
                        <div
                          class="tag__experience"
                          >
                          {{ workExperience.attributes.name }}
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
          </div>
        }
        <div class="d-flex mt-2">
          <button
            class="btn btn-primary rounded-5 ms-auto text-white btn-md flex align-items-center px-3"
            [routerLink]="['/talent-pool']"
            data-umami-event="VIEW_ALL_APPLICATIONS"
            data-umami-event-hr-admin
            >
            <div style="display: flex; align-items: center; font-size: 14px; gap: 5px">
              <span>{{ 'VIEW_ALL_APPLICATIONS' | translate }}</span>
              <mat-icon>arrow_forward</mat-icon>
            </div>
          </button>
        </div>
      </div>
    </div>
  } @else {
    <div class="text-center">
      <p>{{ 'NO_APPLICATIONS_FOUND' | translate }}</p>
    </div>
  }
}

